<div class="cmx-language">
  <div class="cmx-language__heading">{{ layout.languageMobileLabel | async }}</div>
  <div class="cmx-language__options">
    <ul class="cmx-language__options-list">
      <li
        *ngFor="let lang of layout.languages | async"
        class="cmx-language__options-item"
        (click)="selectLang(lang.languageId)"
      >
        <input
          [value]="lang.languageId"
          [(ngModel)]="selectedLangId"
          type="radio"
          class="cmx-language__input"
          [ngClass]="{ 'cmx-language__input--rtl': (layout.direction | async) === 'rtl' }"
        />
        <label
          class="cmx-language__label"
          [ngClass]="{ 'cmx-language__label--rtl': (layout.direction | async) === 'rtl' }"
          for="radio"
          >{{ lang.languageName }}</label
        >
      </li>
    </ul>
  </div>
  <div class="cmx-language__footer" [ngClass]="{ 'cmx-language__footer--rtl': (layout.direction | async) === 'rtl' }">
    <button (click)="cancel()" class="cmx-button cmx-button--support">{{ buttons.cancelLabel | async }}</button>
    <button (click)="apply()" class="cmx-button">{{ buttons.applyLabel | async }}</button>
  </div>
</div>
